/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_FinishInputs */



/**
* | output |
* | --- |
* | "Finish" |
*
* @param {Tfield_FinishInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_finish = /** @type {((inputs?: Tfield_FinishInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_FinishInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Término")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fine")
	return /** @type {LocalizedString} */ ("Finish")
});